import DashboardCreator from './DashboardCreator';

export const KeenDashboardCreator = DashboardCreator;
